import { getCountries, getCountryCallingCode } from "libphonenumber-js";

export const countryCodeList = getCountries().map((country) => ({
    country,
    code: `+${getCountryCallingCode(country)}`,
}));
